import {
  useLoadColumns_LEGACY,
  useLoadRows_LEGACY,
} from '@/features/query-builder/hooks/LEGACY';
import { latestRequestIds } from '@/features/query-builder/latestRequestIds';
import { useAppSelector } from '@/store/hooks';
import {
  selectIsLoadingColumns,
  selectIsLoadingRows,
} from '@/features/query-builder/queryBuilderSlice';

export const useDrilldownError = () => {
  const { error: columnsError, requestId: columnsRequestId } =
    useLoadColumns_LEGACY();
  const { error: rowsError, requestId: rowsRequestId } = useLoadRows_LEGACY();

  const isLoadingColumns = useAppSelector(selectIsLoadingColumns);
  const isLoadingRows = useAppSelector(selectIsLoadingRows);

  if (
    !isLoadingColumns &&
    columnsError &&
    columnsRequestId === latestRequestIds.columns
  ) {
    return `
      ${(columnsError as any).data._msg}
      \n
      ${
        (columnsError as any).data._layerId
          ? 'Please check your last query step.'
          : ''
      }
    `;
  }

  if (!isLoadingRows && rowsError && rowsRequestId === latestRequestIds.rows) {
    if (rowsError.data?._reason === 'EXECUTION_CANCELLED') {
      return 'Query cancelled.\n\nThis error happens if you have Trevor open in another browser tab';
    }

    if (rowsError.data?._reason === 'QUERY_TIMED_OUT') {
      return 'Query timed out. Please try again or adjust your query.\nNote: this error also happens if you have Trevor open in another browser tab.\nIf this problem persists, please contact us.';
    }

    return (
      rowsError.data?._msg ??
      'Loading rows failed.  Please try again or refresh the page.'
    );
  }

  return null;
};
